import { ZoomIn } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon, Modal, Container, Group, Center } from "@mantine/core";
import useDocumentProcessingJobDetailsApiService from "../services/api/DocumentProcessingJobDetailsApiService";
import ErrorPage from "../../../common/pages/ErrorPage";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";

type PDFEmbededObjectProps = {
  fileUrl: string;
  width: string;
  height: string;
};

const PDFEmbededObject: React.FC<PDFEmbededObjectProps> = ({
  fileUrl,
  width,
  height,
}) => (
  <object
    width={width}
    height={height}
    data={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0&view=Fit&&zoom=100%`}
    type="application/pdf"
  >
    <p>
      Alternative text - include a link{" "}
      <a
        href={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0&view=Fit&zoom=100%`}
      >
        to the PDF!
      </a>
    </p>
  </object>
);

type PDFDocumentPreviewPanelProps = {
  id: number;
  onZoom?: () => void;
};

const PDFDocumentPreviewPanel: React.FC<PDFDocumentPreviewPanelProps> = ({
  id,
  onZoom,
}) => {
  const { isLoading, isError, error, data } =
    useDocumentProcessingJobDetailsApiService(id);

  const [zoomIcon, setZoomIcon] = useState(false);

  useEffect(() => {
    if (zoomIcon && onZoom) {
      onZoom();
    }
  }, [zoomIcon, onZoom]);

  if (isError) {
    return <ErrorPage errors={error} />;
  }

  if (isLoading) {
    return <ProgressIndicator />;
  }

  if (!data) {
    return <div />;
  }

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>
  ): void => {
    if (event.key === "Enter" || event.key === " ") {
      setZoomIcon(!zoomIcon);
    }
  };

  return (
    <>
      <Container
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Center style={{ width: "100%", height: "100%" }}>
          <button
            type="button"
            style={{
              cursor: "pointer",
              position: "absolute",
              width: "38%",
              height: 350,
              zIndex: 999999,
              background: "none",
              border: "none",
              padding: 0,
            }}
            onClick={() => setZoomIcon(!zoomIcon)}
            onKeyDown={handleKeyDown}
            aria-label="Zoom PDF"
          />
          <PDFEmbededObject
            fileUrl={`${data.file_url}#toolbar=0&navpanes=0&scrollbar=0&view=Fit&&zoom=100%`}
            width="100%"
            height="100%"
          />
        </Center>
      </Container>

      <Group position="right" style={{ flex: 1, width: "95%" }}>
        <ActionIcon
          color="dark"
          onClick={() => setZoomIcon(!zoomIcon)}
          aria-label="Zoom PDF"
        >
          <ZoomIn size={24} />
        </ActionIcon>
      </Group>

      {zoomIcon && (
        <Modal
          size="80%"
          opened={zoomIcon}
          onClose={() => setZoomIcon(false)}
          title="Employee PDF"
        >
          <PDFEmbededObject
            fileUrl={`${data.file_url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH&&zoom=100%`}
            width="100%"
            height="500"
          />
        </Modal>
      )}
    </>
  );
};

export default PDFDocumentPreviewPanel;
